import React, { useEffect, useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  FlatList,
} from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { Modal } from "react-native-web";
import { useRecoilState, useRecoilValue } from "recoil";
import { tokenState, univer } from "../reducer";
import { addImage } from "../utils";
import { apiservice } from "../service/api";

const { width, height } = Dimensions.get("window");

const manageAppAdmin = () => {
  const [modal, setmodal] = useState(false);
  const [modal1, setmodal1] = useState(false);
  const [modal2, setmodal2] = useState(false);
  const [data1, setdata1] = useState([]);
  const [data2, setdata2] = useState([]);
  const [state, setstate] = useState({});
  const [page, setpage] = useState(0);
  const [page1, setpage1] = useState(1);
  const [university, setuniversity] = useRecoilState(univer);
  const token = useRecoilValue(tokenState);

  async function getallUniversity1() {
    const res = await apiservice({
      path: "/university/all",
      method: "get",
    });
    if (res.status == 200) {
      const res_user = await apiservice({
        path: "/authen/getuseradmin",
        method: "get",
        token: token.accessToken,
      });

      setuniversity(
        res.data.result.filter((item) => {
          return item.id == res_user.data.result.university_id;
        })[0]
      );
    }
  }

  async function getallUniversity() {
    const res = await apiservice({
      path: "/authen/allapp?university_id=" + university.id,
      method: "get",
    });
    if (res.status == 200) {
      setdata1(res.data.data.filter((item) => item.Type == "LOGO"));
      setdata2(res.data.data.filter((item) => item.Type == "BANNER"));
    }
  }

  useEffect(() => {
    getallUniversity();
  }, []);

  return (
    <View style={styles.container}>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal}
        onRequestClose={() => {
          setmodal(!modal);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบข้อมูลนี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  console.log(state);
                  const res = await apiservice({
                    path: "/authen/createdeleteapp",
                    method: "delete",
                    body: { id: state.id },
                  });
                  if (res.status == 200) {
                    getallUniversity();
                    setmodal(false);
                  }
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal2}
        onRequestClose={() => {
          setmodal2(!modal2);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              อัพโหลดรูปไม่สำเร็จ
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal2(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  setmodal2(false);
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <Modal
        animationType="none"
        transparent={true}
        visible={modal1}
        onRequestClose={() => {
          setmodal1(!modal1);
        }}
      >
        <View
          style={{
            width: width,
            height: height,
            backgroundColor: "#000000bb",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: width * 0.5,
              height: height * 0.3,
              backgroundColor: "#fff",
              paddingHorizontal: 20,
              justifyContent: "center",
              alignSelf: "center",
            }}
          >
            <Text
              style={{
                fontSize: 18,
                fontFamily: "Prompt-Bold",
                color: "#202020",
                alignSelf: "center",
              }}
            >
              ต้องการลบข้อมูลนี้ใช่หรือไหม
            </Text>
            <View
              style={{
                width: width * 0.25,
                flexDirection: "row",
                justifyContent: "space-between",
                alignSelf: "center",
                marginTop: 20,
              }}
            >
              <TouchableOpacity
                onPress={() => setmodal1(false)}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ยกเลิก
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  const response = await apiservice({
                    path: "/university/update",
                    method: "put",
                    body: {
                      ...university,
                      logo: "https://api-yb.wishesexistence.co/api/v1/image/getimage/image",
                    },
                  });

                  if (response.status == 200) {
                    getallUniversity1();

                    getallUniversity();
                    setmodal1(false);
                  }
                }}
                style={{
                  width: 120,
                  height: 35,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#000",
                  borderRadius: 5,
                  justifyContent: "center",
                }}
              >
                <Text
                  style={{
                    fontFamily: "Prompt-Regular",
                    fontSize: 16,
                    alignSelf: "center",
                  }}
                >
                  ตกลง
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Text
            style={{
              width: width * 0.591,
              fontSize: 18,
              fontFamily: "Prompt-Bold",
              color: "#202020",
            }}
          >
            จัดการแอพพลิเคชั่น
          </Text>
          <View style={{ width: width * 0.591, flexDirection: "row" }}>
            <TouchableOpacity
              onPress={() => setpage1(1)}
              style={{
                borderBottomWidth: 1,
                borderColor: page1 == 1 ? "#002377" : "#ffff",
                marginRight: 20,
              }}
            >
              <Text
                style={{
                  fontSize: 25,
                  fontFamily: "Prompt-Regular",
                  color: "#202020",
                }}
              >
                โลโก้
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage1(2)}
              style={{
                borderBottomWidth: 1,
                borderColor: page1 == 2 ? "#002377" : "#ffff",
              }}
            >
              <Text
                style={{
                  fontSize: 25,
                  fontFamily: "Prompt-Regular",
                  color: "#202020",
                }}
              >
                ภาพปก
              </Text>
            </TouchableOpacity>
          </View>

          {page1 == 1 && (
            <View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.06,
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={async () => {
                    const res = await addImage();
                    const response = await apiservice({
                      path: "/university/update",
                      method: "put",
                      body: { ...university, logo: res },
                    });
                    if (response.status == 200) {
                      getallUniversity1();
                    }
                  }}
                  style={{
                    width: width * 0.045,
                    height: height * 0.037,
                    backgroundColor: "#43A2D4",
                    borderRadius: 5,
                  }}
                >
                  <Text style={styles.TextButton}>เปลี่ยน</Text>
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.6,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#C2C2C2",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }}
              >
                <View
                  style={{
                    width: width * 0.591,
                    height: height * 0.054,
                    backgroundColor: "#002377",
                    flexDirection: "row",
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                    justifyContent: "space-around",
                  }}
                >
                  <View
                    style={{
                      width: width * 0.076,
                      height: height * 0.054,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { margin: "auto", color: "#FFF" },
                      ]}
                    >
                      ลำดับ
                    </Text>
                  </View>
                  <View
                    style={{
                      width: width * 0.2,
                      height: height * 0.054,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { margin: "auto", color: "#FFF" },
                      ]}
                    >
                      รูปภาพ
                    </Text>
                  </View>
                  <View
                    style={{
                      width: width * 0.082,
                      height: height * 0.054,
                      justifyContent: "center",
                    }}
                  >
                    <Text style={styles.Textheader}></Text>
                  </View>
                </View>

                <FlatList
                  data={[""]}
                  renderItem={({ item, index }) => {
                    return (
                      <View
                        style={{
                          width: width * 0.591,
                          height: height * 0.25,
                          flexDirection: "row",
                          justifyContent: "space-around",
                          backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                        }}
                      >
                        <View
                          style={{
                            width: width * 0.076,
                            height: height * 0.25,
                          }}
                        >
                          <Text style={[styles.Textdata, { margin: "auto" }]}>
                            {index + 1}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.121,
                            height: height * 0.25,
                          }}
                        >
                          <View
                            style={{
                              width: width * 0.104,
                              height: width * 0.103,
                              borderRadius: width * 0.103,
                              borderWidth: 1,
                              overflow: "hidden",
                              borderColor: "#00000050",
                              margin: "auto",
                              backgroundColor: "#ffff",
                            }}
                          >
                            <Image
                              style={{
                                width: width * 0.103,
                                height: width * 0.103,
                              }}
                              source={{ uri: university.logo }}
                            />
                          </View>
                        </View>

                        <View
                          style={{
                            width: width * 0.082,
                            height: height * 0.25,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <TouchableOpacity
                            onPress={() => {
                              setstate(item);
                              setTimeout(() => {
                                setmodal1(true);
                              }, 300);
                            }}
                          >
                            <MaterialIcons
                              name="delete"
                              size={24}
                              color="black"
                            />
                          </TouchableOpacity>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </View>
          )}
          {page1 == 2 && (
            <View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.06,
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginBottom: 16
                }}
              >
                <View style={{ width: '100%', alignItems: 'flex-end' }}>
                  <TouchableOpacity
                    onPress={async () => {
                      const res = await addImage();
                      if (res) {
                        const response = await apiservice({
                          path: "/authen/createapp",
                          method: "POST",
                          body: {
                            name: res,
                            image_url: res,
                            link: res,
                            Type: "BANNER",
                            university_id: university.id,
                          },
                        });
                        if (response.status == 200) {
                          getallUniversity();
                        }
                      } else {
                        alert.alert("aaaa");
                      }
                    }}
                    style={{
                      width: width * 0.045,
                      height: height * 0.037,
                      backgroundColor: "#43A2D4",
                      borderRadius: 5,
                    }}
                  >
                    <Text style={styles.TextButton}>+ เพิ่ม</Text>
                  </TouchableOpacity>
                  <View>
                    <Text style={[styles.TextButton, { color: '#000', textAlign: 'right' }]}>ขนาดรูปที่แนะนำ 1300 x 541 px</Text>
                  </View>
                </View>
              </View>
              <View
                style={{
                  width: width * 0.591,
                  height: height * 0.6,
                  borderWidth: 1,
                  overflow: "hidden",
                  borderColor: "#C2C2C2",
                  borderTopLeftRadius: 5,
                  borderTopRightRadius: 5,
                }}
              >
                <View
                  style={{
                    width: width * 0.591,
                    height: height * 0.054,
                    backgroundColor: "#002377",
                    flexDirection: "row",
                    borderTopLeftRadius: 5,
                    borderTopRightRadius: 5,
                    justifyContent: "space-around",
                  }}
                >
                  <View
                    style={{
                      width: width * 0.076,
                      height: height * 0.054,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { margin: "auto", color: "#FFF" },
                      ]}
                    >
                      ลำดับ
                    </Text>
                  </View>
                  <View
                    style={{
                      width: width * 0.2,
                      height: height * 0.054,
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={[
                        styles.Textheader,
                        { margin: "auto", color: "#FFF" },
                      ]}
                    >
                      รูปภาพ
                    </Text>
                  </View>
                  <View
                    style={{
                      width: width * 0.082,
                      height: height * 0.054,
                      justifyContent: "center",
                    }}
                  >
                    <Text style={styles.Textheader}></Text>
                  </View>
                </View>

                <FlatList
                  data={data2}
                  renderItem={({ item, index }) => {
                    return (
                      <View
                        style={{
                          width: width * 0.591,
                          height: height * 0.25,
                          flexDirection: "row",
                          justifyContent: "space-around",
                          backgroundColor: index % 2 == 0 ? "#ffff" : "#E8E8E8",
                        }}
                      >
                        <View
                          style={{
                            width: width * 0.076,
                            height: height * 0.25,
                          }}
                        >
                          <Text style={[styles.Textdata, { margin: "auto" }]}>
                            {index + 1}
                          </Text>
                        </View>
                        <View
                          style={{
                            width: width * 0.121,
                            height: height * 0.25,
                          }}
                        >
                          <View
                            style={{
                              width: width * 0.125,
                              aspectRatio: 682 / 283,
                              borderRadius: 5,
                              borderWidth: 1,
                              overflow: "hidden",
                              borderColor: "#00000050",
                              margin: "auto",
                              backgroundColor: "#ffff",
                            }}
                          >
                            <Image
                              style={{
                                width: width * 0.125,
                                aspectRatio: 682 / 283,
                              }}
                              source={{ uri: item.image_url }}
                            />
                          </View>
                        </View>

                        <View
                          style={{
                            width: width * 0.082,
                            height: height * 0.25,
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <TouchableOpacity
                            onPress={() => {
                              console.log(item);
                              setstate(item);
                              setTimeout(() => {
                                setmodal(true);
                              }, 300);
                            }}
                          >
                            <MaterialIcons
                              name="delete"
                              size={24}
                              color="black"
                            />
                          </TouchableOpacity>
                        </View>
                      </View>
                    );
                  }}
                />
              </View>
            </View>
          )}
        </View>
      )}

      {page == 1 && <View />}
      {page == 1 && <View />}
      {page == 1 && <View />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Textheader: {
    fontSize: 20,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
  Textdata: { fontSize: 16, margin: "auto", fontFamily: "Prompt-Regular" },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});
export default manageAppAdmin;
